import { Box } from '@chakra-ui/react'

/** A6 §4.3: content gains a max-width so panels stop stretching edge-to-edge at 1440. */
export const CONTENT_MAX_WIDTH = '1440px'

/** Routes that intentionally render edge-to-edge (full-screen maps) and must NOT be capped. */
export const FULL_BLEED_PREFIXES = ['/dashboard/analytics-map', '/dashboard/turf-maps/new']

function isFullBleed(pathname: string): boolean {
  return FULL_BLEED_PREFIXES.some((p) => pathname === p || pathname.startsWith(p + '/'))
}

export function MainContentRegion({ pathname, children }: { pathname: string; children: React.ReactNode }) {
  if (isFullBleed(pathname)) {
    return <Box>{children}</Box>
  }
  // Inline style (not a Chakra maxW token) so the value is directly assertable and obviously the cap.
  return <Box style={{ maxWidth: CONTENT_MAX_WIDTH }} mx="auto">{children}</Box>
}
